export var ON_INIT_CHANGE_ID = 'onInitChangeId';
export var UI_MODIFICATIONS_MODULE = 'jira:uiModifications';